import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

import prmLogoWhite from '_assets/images/gateway/prm-logo-white.png';

const SESSION_KEY = 'prm-welcome-dismissed';

const modalStyle = {
  overlay: {
    zIndex: 200,
    background: 'rgba(16,27,49,0.82)',
    backdropFilter: 'blur(6px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 28,
  },
  content: {
    position: 'relative',
    inset: 'auto',
    width: '100%',
    maxWidth: 760,
    maxHeight: '100%',
    overflow: 'auto',
    borderRadius: 28,
    background: '#fff',
    boxShadow: '0 40px 90px rgba(9,17,33,0.5)',
    border: 'none',
    padding: 0,
  },
};

// Shown once per browser session (sessionStorage), dismissible via Enter/close
// button/Escape/backdrop click — all handled by react-modal itself.
const WelcomeModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    try {
      if (window.sessionStorage.getItem(SESSION_KEY) === '1') return;
    } catch (e) {
      // storage unavailable — fall through and show it
    }
    setIsOpen(true);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const close = () => {
    try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* ignore */ }
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      ariaHideApp={false}
      contentLabel="Welcome to PRM Assist"
      style={modalStyle}
    >
      <div style={{ position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', gap: 18, padding: '20px 26px', background: '#1c2b4a', borderBottom: '3px solid #208aef' }}>
        <img src={prmLogoWhite} alt="PRM Assist" style={{ height: 26, width: 'auto', display: 'block' }} />
        <p style={{ margin: '0 0 0 auto', display: 'flex', alignItems: 'center', gap: 10, fontSize: 12, fontWeight: 700, letterSpacing: '.2em', textTransform: 'uppercase', color: '#7fbcff' }}>
          <span aria-hidden="true" style={{ width: 9, height: 9, borderRadius: '50%', background: '#7fbcff', animation: 'gwGatePulse 2.4s ease-in-out infinite' }} />
          Now boarding
        </p>
        <span aria-hidden="true" style={{ position: 'absolute', left: 0, bottom: 8, color: '#7fbcff', fontSize: 20, lineHeight: 1, animation: 'gwCross 9s cubic-bezier(.45,0,.55,1) infinite' }}>
          <svg viewBox="0 0 24 24" width={20} height={20} style={{ display: 'block', transform: 'rotate(90deg)' }} aria-hidden="true">
            <path fill="currentColor" d="M21,16V14L13,9V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V9L2,14V16L10,13.5V19L8,20.5V22L11.5,21L15,22V20.5L13,19V13.5L21,16Z" />
          </svg>
        </span>
      </div>

      <div style={{ padding: '52px 52px 44px' }}>
        <p style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '0 0 22px', fontSize: 12, fontWeight: 700, letterSpacing: '.2em', textTransform: 'uppercase', color: '#1670c8' }}>
          <span aria-hidden="true">→</span> Welcome aboard
        </p>
        <h2 style={{ margin: 0, fontSize: 'clamp(32px, 4.4vw, 54px)', lineHeight: 0.98, fontWeight: 800, letterSpacing: '-0.03em', textTransform: 'uppercase', color: '#1c2b4a' }}>
          Welcome To PRM Assist.
        </h2>
        <div aria-hidden="true" style={{ margin: '28px 0', height: 1, background: '#208aef', opacity: 0.45 }} />
        <p style={{ margin: 0, maxWidth: '22em', fontSize: 'clamp(22px, 2.6vw, 32px)', lineHeight: 1.08, fontWeight: 800, letterSpacing: '-0.02em', textTransform: 'uppercase', color: '#208aef' }}>
          Now Boarding The Future of Accessible Aviation
        </p>
        <div style={{ margin: '40px 0 0' }}>
          <button type="button" className="gw-welcome-cta" onClick={close} style={{ display: 'inline-flex', alignItems: 'center', gap: 12, minHeight: 52, padding: '15px 34px', border: 0, borderRadius: 12, background: '#1c2b4a', color: '#fff', fontFamily: 'inherit', fontSize: 15, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', cursor: 'pointer' }}>
            Enter
            <span aria-hidden="true" className="gw-arrow">→</span>
          </button>
        </div>
      </div>

      <button type="button" className="gw-icon-btn" onClick={close} aria-label="Close welcome message" style={{ position: 'absolute', top: 74, right: 22, width: 44, height: 44, display: 'grid', placeItems: 'center', border: '1px solid rgba(32,138,239,0.28)', borderRadius: 12, background: '#fff', color: '#1670c8', cursor: 'pointer' }}>
        <svg viewBox="0 0 24 24" width={20} height={20} aria-hidden="true">
          <path fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
    </Modal>
  );
};

export default WelcomeModal;
